export default "__VITE_ASSET__D1qAr8J8__"